module.exports = __webpack_public_path__ + "static/media/15_3.4a63cdaf.jpg";